import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { useEffect, useState } from "react";

const Summary = ({ title, data }) => {
  const synth = window.speechSynthesis;
  const handleClick = (text) => {
    const speech = new SpeechSynthesisUtterance();
    speech.text = text;
    if (synth.pending) {
      synth.cancel();
    }
    if (synth.paused) {
      synth.resume(speech);
    }
    if (synth.speaking) {
      synth.pause(speech);
    }
    synth.speak(speech);
  };
  useEffect(() => {
    return () => {
      synth.cancel();
    };
  });
  const [view, setView] = useState(true);
  return (
    <div className="summery">
      <div className="head">
        <h3>{title}</h3>
        <button onClick={() => handleClick(data)}>
          <VolumeUpIcon />
          click to play
        </button>
      </div>
      <div className="line"></div>
      <div className="para">
        {view ? (
          <p>
            {data?.length > 350 ? data?.slice(0, 350) :  data }
            {data?.length > 350 && (
              <span onClick={() => setView(false)}>...see more</span>
            )}
          </p>
        ) : (
          <p>
            {data}
            <span onClick={() => setView(true)}>...see less</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default Summary;
